export const createWirelessAlarmTypesDataSource = (alarmTypes) => {
    if (!alarmTypes) {
        return [];
    }
    return alarmTypes.map((item) => {
        return { value: item.value, label: item.value };
    });
};
